import { CountertopIcon } from './CountertopIcon';

/**
 * author: Google
 * id 795A2085-78E1-4721-BF6F-007B20CF92AF
 * name countertop
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/countertop.svg
 * tags
 * - Home Automation 
 */
export const KitchenCounterIcon = CountertopIcon;
export default KitchenCounterIcon